import { rem } from "polished"

const searchResult = {
  br: rem(8),
  backgroundColor: ({ theme }) => theme.colors.white,
  labelColor: ({ theme }) => theme.colors.white,
  labelBackgroundColor: ({ theme }) => theme.colors.lightGreen,
  labelBr: rem(5),
}

export default searchResult
